import React from "react";
import classNames from "classnames";

const Label = ({
  htmlFor,
  className,
  children,
  isColForLabel,
  isHidden,
  size,
  title,
  ariaLabelledby,
  ariaLabel,
  ...props
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={classNames(
        "form-label",
        {
          "col-form-label": isColForLabel,
          [`col-form-label-${size}`]: isColForLabel && !!size,
          "visually-hidden": isHidden,
        },
        className
      )}
      title={title}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      {...props}
    >
      {children}
    </label>
  );
};

export default Label;
